/*
  Product page "Bought together / Also fits your vehicle" carousel
  (snippets/bought-together.liquid).

  The filter, order, badges and heading are drawn by window.pbtRender, printed
  inline after the carousel so they are in place before it paints. This
  element re-runs it on every PartBot vehicle event and adds the arrows, dots,
  option prefetch and add to cart.
*/
if (!customElements.get('bought-together')) {
  (function () {
    var LS_KEY = 'partbot_selected_vehicle';
    var EVENTS = ['vehicle-garage-change', 'vehicle-search-change', 'plate-search-change', 'partbot-clear-vehicle'];

    function openGarage() {
      var triggers = document.querySelectorAll('[data-garage-trigger]');
      for (var i = 0; i < triggers.length; i++) {
        if (!triggers[i].closest('cart-drawer')) { triggers[i].click(); return; }
      }
      if (triggers[0]) triggers[0].click();
    }

    class BoughtTogether extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.track = this.querySelector('.pbt__track');
        this.dots = this.querySelector('.pbt__dots');
        this.heading = this.querySelector('.pbt__heading');
        this.garageBtn = this.querySelector('[data-pbt-garage]');

        this.render = this.render.bind(this);
        EVENTS.forEach(function (ev) {
          window.addEventListener(ev, this.render);
          document.addEventListener(ev, this.render);
        }, this);
        window.addEventListener('storage', (e) => { if (!e.key || e.key === LS_KEY) this.render(); });

        this.garageBtn.addEventListener('click', openGarage);
        this.addEventListener('click', this.onAdd.bind(this));
        this.setupDots();
        this.setupArrows();
        this.prefetchOptions();
        this.setupMouseScroll();
        this.render();
      }

      render() {
        if (window.pbtRender) window.pbtRender(this);
        this.renderDots();
        this.updateArrows();
      }

      /* Desktop: step one card at a time; disabled at either end. */
      setupArrows() {
        this.prevBtn = this.querySelector('[data-pbt-prev]');
        this.nextBtn = this.querySelector('[data-pbt-next]');
        var step = (dir) => {
          var slides = this.visibleSlides();
          if (!slides.length) return;
          var left = this.track.scrollLeft;
          var current = 0;
          slides.forEach(function (s, i) {
            if (Math.abs(s.offsetLeft - left) < Math.abs(slides[current].offsetLeft - left)) current = i;
          });
          var target = slides[Math.max(0, Math.min(slides.length - 1, current + dir))];
          this.track.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
        };
        this.prevBtn.addEventListener('click', function () { step(-1); });
        this.nextBtn.addEventListener('click', function () { step(1); });
        this.track.addEventListener('scroll', () => {
          clearTimeout(this.arrowTimer);
          this.arrowTimer = setTimeout(() => this.updateArrows(), 60);
        }, { passive: true });
      }

      updateArrows() {
        if (!this.prevBtn) return;
        var max = this.track.scrollWidth - this.track.clientWidth;
        this.prevBtn.disabled = this.track.scrollLeft <= 2;
        this.nextBtn.disabled = this.track.scrollLeft >= max - 2;
        this.querySelector('.pbt__nav').hidden = this.visibleSlides().length < 2;
      }

      /*
        "Choose options" fetches its panel on first tap, which showed a spinner.
        Once the carousel is near the screen, fetch the panels for the cards on
        show (a few at a time, when the browser is idle) so the tap opens at once.
      */
      prefetchOptions() {
        var run = () => {
          var panels = this.visibleSlides()
            .map(function (li) { return li.querySelector('quick-add-panel'); })
            .filter(function (p) { return p && typeof p.loadDialog === 'function'; })
            .slice(0, 6);
          var next = function () {
            var p = panels.shift();
            if (!p) return;
            p.loadDialog().catch(function () {}).then(function () { setTimeout(next, 150); });
          };
          next();
        };
        var idle = window.requestIdleCallback || function (cb) { setTimeout(cb, 300); };
        if (!('IntersectionObserver' in window)) return idle(run);
        var io = new IntersectionObserver((entries) => {
          if (!entries.some(function (e) { return e.isIntersecting; })) return;
          io.disconnect();
          idle(run);
        }, { rootMargin: '400px 0px' });
        io.observe(this);
      }

      visibleSlides() {
        return Array.prototype.filter.call(this.track.children, function (li) { return !li.hidden; });
      }

      setupDots() {
        this.dots.addEventListener('click', (e) => {
          var dot = e.target.closest('button[data-index]');
          if (!dot) return;
          var slide = this.visibleSlides()[Number(dot.dataset.index)];
          if (slide) this.track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        });
        this.track.addEventListener('scroll', () => {
          if (this.dotFrame) return;
          this.dotFrame = requestAnimationFrame(() => { this.dotFrame = null; this.markDot(); });
        }, { passive: true });
      }

      renderDots() {
        var count = this.visibleSlides().length;
        this.dots.hidden = count < 2;
        this.dots.innerHTML = Array.from({ length: count }, function (_, i) {
          return '<button type="button" data-index="' + i + '" aria-label="Show product ' + (i + 1) + ' of ' + count + '"></button>';
        }).join('');
        this.markDot();
      }

      markDot() {
        var slides = this.visibleSlides();
        if (!slides.length) return;
        var left = this.track.scrollLeft;
        var active = 0;
        slides.forEach(function (s, i) {
          if (Math.abs(s.offsetLeft - left) < Math.abs(slides[active].offsetLeft - left)) active = i;
        });
        Array.prototype.forEach.call(this.dots.children, function (d, i) { d.toggleAttribute('aria-current', i === active); });
      }

      /* Mouse users can drag the row; a click that ends a drag never opens a product. */
      setupMouseScroll() {
        var track = this.track;
        var startX = 0, startLeft = 0, dragging = false, moved = false;
        track.addEventListener('pointerdown', function (e) {
          if (e.pointerType !== 'mouse' || e.button !== 0 || e.target.closest('button, select, input')) return;
          dragging = true; moved = false; startX = e.clientX; startLeft = track.scrollLeft;
        });
        window.addEventListener('pointermove', function (e) {
          if (!dragging) return;
          var dx = e.clientX - startX;
          if (!moved && Math.abs(dx) < 5) return;
          if (!moved) { moved = true; track.classList.add('is-dragging'); }
          track.scrollLeft = startLeft - dx;
        });
        window.addEventListener('pointerup', () => {
          if (!dragging) return;
          dragging = false;
          if (!moved) return;
          track.classList.remove('is-dragging');
          var slides = this.visibleSlides();
          var left = track.scrollLeft;
          var nearest = slides.reduce(function (best, s) {
            return Math.abs(s.offsetLeft - left) < Math.abs(best.offsetLeft - left) ? s : best;
          }, slides[0]);
          if (nearest) track.scrollTo({ left: nearest.offsetLeft, behavior: 'smooth' });
        });
        track.addEventListener('click', function (e) {
          if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
        }, true);
      }

      async onAdd(e) {
        var btn = e.target.closest('[data-pbt-add]');
        if (!btn || btn.classList.contains('loading')) return;
        var status = btn.querySelector('.pbt__status');
        btn.classList.add('loading');
        btn.setAttribute('aria-disabled', 'true');

        var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        var config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        var body = new FormData();
        body.append('id', btn.dataset.pbtAdd);
        body.append('quantity', 1);
        if (cart) {
          body.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
          body.append('sections_url', window.location.pathname);
        }
        config.body = body;

        try {
          var res = await fetch(routes.cart_add_url, config);
          var response = await res.json();
          if (response.status) {
            status.textContent = response.description || 'Error';
            setTimeout(function () { status.textContent = 'Add to cart'; }, 2500);
            return;
          }
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bought-together', productVariantId: btn.dataset.pbtAdd, cartData: response });
          }
          if (cart) cart.renderContents(response);
          else window.location = window.routes.cart_url;
        } catch (err) {
          console.error('[bought-together]', err);
          status.textContent = 'Error';
          setTimeout(function () { status.textContent = 'Add to cart'; }, 2500);
        } finally {
          btn.classList.remove('loading');
          btn.removeAttribute('aria-disabled');
        }
      }
    }

    customElements.define('bought-together', BoughtTogether);
  })();
}
